import { InjectionToken } from '@angular/core';

export interface UiMenuContext {
  close: () => void;
}

export const UI_MENU_CONTEXT = new InjectionToken<UiMenuContext>(
  'UI_MENU_CONTEXT',
);
